import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {UtilitiesService} from "../shared/services/utilities.service";
import {CoreService} from "../shared/services/core.service";
@Injectable({
  providedIn: 'root'
})
export class BackButtonGuard implements CanActivate {
  constructor(private coreService: CoreService) {
  }
  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return !this.coreService.isManualNavigation;
  }
}
